export default { sha: 'ced792c4da4b88bb5f6a4976de103ba9018b7776', buildNumber: 'undefined' }
